import { useEffect, useMemo } from "react";
import { backgroundFor, preloadBackground } from "../background.js";
import { useStore } from "../state/store.js";
import { artCss } from "../assets.js";

// Glass over the daily background image. Two layers, one per theme, both
// preloaded for the active day so the theme toggle crossfades with no
// network wait; the image never changes on a theme flip, only the suffix.
export function Background() {
  const theme = useStore((s) => s.theme);
  const bg = useMemo(() => backgroundFor(new Date()), []);

  useEffect(() => {
    preloadBackground(bg);
  }, [bg]);

  return (
    <div className="bglayer" aria-hidden="true">
      <div
        className="bg"
        data-active={theme === "light"}
        style={{ backgroundImage: artCss(bg.light) }}
      />
      <div
        className="bg"
        data-active={theme === "dark"}
        style={{ backgroundImage: artCss(bg.dark) }}
      />
      <div className="bgscrim" />
    </div>
  );
}
